module.exports = __webpack_public_path__ + "static/media/normal.fc43f0d8.jpg";